import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { saveAs } from "file-saver";
import { DownloadHistoriesClient, IDownloadHistoriesClient } from "app/ApiClient";
import { initialReportsState } from "./reportsState";

const downloadHistoriesClient: IDownloadHistoriesClient = new DownloadHistoriesClient(
  process.env.REACT_APP_API_URL,
);

export const getDownloadsReport = createAsyncThunk(
  "reports/getDownloadsReport", async (_, { rejectWithValue }) => {
    try {
      const result = await downloadHistoriesClient.getCsv();
      saveAs(result.data);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const reportsSlice = createSlice({
  name: "reports",
  initialState: initialReportsState,
  reducers: {
    resetDownloadStatus: (state) => {
      state.downloadingState = LoadingState.idle
    },
  },
  extraReducers: (builder) => {

    builder.addCase(getDownloadsReport.pending, (state) => {
      state.downloadingState = LoadingState.pending;
      state.errorMessage = undefined;
    });
    builder.addCase(getDownloadsReport.fulfilled, (state) => {
      state.downloadingState = LoadingState.succeed;
      state.errorMessage = undefined;
    });
    builder.addCase(getDownloadsReport.rejected, (state, {error}) => {
      state.downloadingState = LoadingState.failed;
      state.errorMessage = error.message;
    });
  },
});
export const { resetDownloadStatus } = reportsSlice.actions;
export default reportsSlice.reducer;
